export const LEADERS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_title_color: "",
    meta_sub_title: "",
    meta_sub_title_color: "",
    meta_image: "",
    meta_alt_image: "",
    meta_icon: "",
    meta_alt_icon: "",
    meta_video_link: "",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_TITLES: {
    metadata: "Leaders",
  },

  LEADERS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Learning From Where ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter pre title",
      required: false,
      defaultValue: "Learning From Where ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#222222CC",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#222222CC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Wealth Is Actually Managed",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title",
      required: false,
      defaultValue: "Wealth Is Actually Managed",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Optional gradient end",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Scroll frequency (milliseconds)eg. 5000",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_box_start_color",
      label: "Description Box Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "description_box_end_color",
      label: "Description Box End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "description_box_gradient_angle",
      label: "Description Box Gradient Angle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_section_pre_title",
      label: "Description Section Pre Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter description section pre title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_section_pre_title_color",
      label: "Description Section Pre Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_section_title",
      label: "Description Section Title",
      value: "Learn from leaders managing billions in client wealth",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter description section title",
      required: false,
      defaultValue: "Learn from leaders managing billions in client wealth",
    },
    {
      fieldName: "description_section_title_color",
      label: "Description Section Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_section_description",
      label: "Description Section Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_section_description_text_color",
      label: "Description Section Description Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    { header: "Title", fieldName: "meta_title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Title", required: false },
    { header: "Title Color", fieldName: "meta_title_color", value: "", valueType: "string", filedType: "COLOR", required: false },
    { header: "Sub Title", fieldName: "meta_sub_title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Sub title", required: false },
    { header: "Sub Title Color", fieldName: "meta_sub_title_color", value: "", valueType: "string", filedType: "COLOR", required: false },
    { header: "Image", fieldName: "meta_image", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload image", required: false },
    { header: "Image Alt", fieldName: "meta_alt_image", value: "", valueType: "string", filedType: "INPUT", placeholder: "Alt text", required: false },
    { header: "Icon", fieldName: "meta_icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload icon", required: false },
    { header: "Icon Alt", fieldName: "meta_alt_icon", value: "", valueType: "string", filedType: "INPUT", placeholder: "Alt text", required: false },
    { header: "Video Link", fieldName: "meta_video_link", value: "", valueType: "string", filedType: "INPUT", placeholder: "Video URL (e.g. YouTube, Vimeo)", required: false },
    { header: "Priority", fieldName: "meta_priority", value: 1, valueType: "number", filedType: "INPUT", placeholder: "Priority", required: true },
    { header: "Status", fieldName: "meta_status", value: 1, valueType: "number", filedType: "INPUT", placeholder: "1 = active", required: false },
  ],
};
